import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { GraphRiskComponent } from '../graph-risk/graph-risk.component';

@Component({
   selector: 'app-widget-panel',
   standalone: true,
   imports: [
      CommonModule,
      FormsModule,
      CalendarModule,
      DropdownModule,
      CardModule,
      ButtonModule,
      CheckboxModule,
      GraphRiskComponent
   ],
   templateUrl: './widget-panel.component.html',
   styleUrls: ['./widget-panel.component.scss']
})
export class WidgetPanelComponent implements OnInit {
   isOpen = true;
   localStorageKey = 'dashboardWidgetState';

   selectedTypes: string[] = ['Daily'];
   workflowOptions = [
      { label: 'Daily Rate Check', value: 'dailyRateCheck' },
      { label: 'Credit Limit Review', value: 'creditLimitReview' },
      { label: 'Room Status Audit', value: 'roomStatusAudit' }
   ];
   selectedWorkflow: string | null = null;
   launchDate: Date = new Date();

   ngOnInit(): void {
      const saved = localStorage.getItem(this.localStorageKey);
      this.isOpen = saved !== 'false';
   }

   toggleWidget(): void {
      this.isOpen = !this.isOpen;
      localStorage.setItem(this.localStorageKey, this.isOpen.toString());
   }
}
